/**
 * Wake Lock Manager
 * Prevents screen from locking during timer operation
 * Uses Screen Wake Lock API (iOS 16.4+, Android Chrome 84+)
 */

class WakeLockManager {
  constructor() {
    this.wakeLock = null;
    this.isSupported = 'wakeLock' in navigator;
  }

  /**
   * Check if Wake Lock API is supported
   */
  isAvailable() {
    return this.isSupported;
  }

  /**
   * Request wake lock to keep screen awake
   */
  async request() {
    if (!this.isSupported) {
      console.warn('Wake Lock API not supported on this device');
      return false;
    }

    // Release existing lock if any
    if (this.wakeLock) {
      await this.release();
    }

    try {
      this.wakeLock = await navigator.wakeLock.request('screen');
      console.log('Wake Lock activated - screen will stay awake');

      // Listen for wake lock release
      this.wakeLock.addEventListener('release', () => {
        console.log('Wake Lock released');
      });

      return true;
    } catch (err) {
      // Common errors:
      // - NotAllowedError: Permission denied or document not visible
      // - AbortError: Low battery
      console.error('Wake Lock request failed:', err.name, err.message);
      return false;
    }
  }

  /**
   * Release wake lock (allow screen to lock again)
   */
  async release() {
    if (this.wakeLock) {
      try {
        await this.wakeLock.release();
        this.wakeLock = null;
        console.log('Wake Lock manually released');
        return true;
      } catch (err) {
        console.error('Wake Lock release failed:', err);
        return false;
      }
    }
    return true;
  }

  /**
   * Check if wake lock is currently active
   */
  isActive() {
    return this.wakeLock !== null;
  }
}

// Export singleton instance
export const wakeLockManager = new WakeLockManager();
